module.exports = __webpack_public_path__ + "static/media/logo-white-icon.99e9646c.svg";